import { SvgIcon } from "@mui/material"

import { ReactComponent as InfoOutline } from "./InfoOutline.svg"

export const InfoOutlineIcon = (props) => {
    return (
        <SvgIcon component={InfoOutline} {...props} inheritViewBox />
    )
}